import React, { useEffect, useState } from 'react';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import SvgTagEdit from '@components/ringil3/icons/TagEdit.tsx';
import RingilInputSwitch from '@components/framework/input/RingilInputSwitch/RingilInputSwitch.tsx';

interface ComponentProps {
  secured?: SecuredConfig;
  label: string;
  value: boolean;
  yesLabel: string;
  noLabel: string;
  switchLabel: string;
  helpText?: string;
  onChange: (value: boolean) => void;
  icon?: React.ReactElement;
  readOnly?: boolean;
  dataTestId?: string;
}

const LocationBooleanTag: React.FC<ComponentProps> = ({ secured, label, value, yesLabel, noLabel, switchLabel, helpText, onChange, icon, readOnly, dataTestId }) => {
  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => setInternalValue(value), [value]);

  return (
    <ButtonTag
      secured={secured}
      label={label}
      icon={icon}
      value={value ? yesLabel : noLabel}
      actionIcon={<SvgTagEdit />}
      actionPane={
        <div className="flex flex-col gap-1">
          <RingilInputSwitch label={switchLabel} value={internalValue} onChange={v => setInternalValue(v)} />
          {helpText && <span className="text-sm text-content-secondary">{helpText}</span>}
        </div>
      }
      onSave={onSuccess => {
        onChange(internalValue);
        onSuccess();
      }}
      readonly={readOnly}
      autoClose
      dataTestId={dataTestId}
    />
  );
};

export default LocationBooleanTag;
